import { render, staticRenderFns } from "./Item-horizontal.vue?vue&type=template&id=9a17d4ec&scoped=true&"
import script from "./Item-horizontal.vue?vue&type=script&lang=js&"
export * from "./Item-horizontal.vue?vue&type=script&lang=js&"
import style0 from "./Item-horizontal.vue?vue&type=style&index=0&id=9a17d4ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a17d4ec",
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow})
    

export default component.exports